// extracted by mini-css-extract-plugin
module.exports = {"root":"StoreFooter_root__IaEzh","suggest_product":"StoreFooter_suggest_product__IRYHa"};